import { useQuery } from 'react-query';
import fetchHelper from './fetchHelper';
import useEventEmitter from './useEventEmitter';
import { USE_RETRIEVE_DATA_EVENTS } from "./useRetrieveData";

export const defaultQueryFn = async (retrievalUrl) => {
    const response = await fetchHelper(retrievalUrl);
    return await response.json();
};

export const reactQueryDefaultOptions = {
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: Infinity,
    notifyOnChangeProps: 'tracked',
    retry: (failureCount, error) => {
        if (error?.retry === false) {
            return false;
        }
        return failureCount <= 3;
    }
};

export default function useQueryFetch(componentName, retrievalUrl, useQueryOptions = {}) {
    const applyEmitterHandler = useEventEmitter(componentName);

    return useQueryFetchWithoutEmitter(componentName, retrievalUrl, { 
        onError: (err) => { 
            applyEmitterHandler((emitter) => {
                emitter.emit(USE_RETRIEVE_DATA_EVENTS.ON_FETCH_ERROR, err);
            });
        },
        onSuccess: (data) => {
            applyEmitterHandler((emitter) => {
                emitter.emit(USE_RETRIEVE_DATA_EVENTS.ON_FETCH_SUCCESS, data);
            });
        },
        ...useQueryOptions 
    });
}

export function useQueryFetchWithoutEmitter(componentName, retrievalUrl, useQueryOptions = {}) {
    return useQuery([componentName, retrievalUrl], () => defaultQueryFn(retrievalUrl), {
        ...reactQueryDefaultOptions,
        ...useQueryOptions
    });
}